import { DELAY } from 'src/app/core/utils/constants';
import { PETICIONES } from './../utils/constants';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { delay } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class UsersService {
    readonly BASE: any = PETICIONES.users;

    constructor(private http: HttpClient) { }

  /**
   * @description
   * Obtiene todos los usuarios
   */
  public findAll(): Observable<any> {
    return this.http.get(this.BASE.findAll).pipe(delay(DELAY));
  }

  /**
  * @description
  * Obtiene un usuario por su id
  */
  public findById(id: number): Observable<any> {
    let idUsuario: string = (id !== undefined && id !== null ? id + "" : "");
    return this.http.get(this.BASE.findById + "/" + idUsuario).pipe(delay(DELAY));
  }

  /**
  * @description
  * Obtiene un usuario por su id
  */
  public findByLogin(user: string): Observable<any> {
    let loginUsuario: string = (user !== undefined && user !== null ? user + "" : "");
    return this.http.get(this.BASE.findByLogin + "/" + loginUsuario).pipe(delay(DELAY));
  }

}